module.exports = __webpack_public_path__ + "static/media/integral.f0bc5fd4.svg";